// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"JO","tooltipWrapper":"KO","icon":"LO","tooltip":"MO","content":"NO"};